module.exports = __webpack_public_path__ + "static/media/icon-skins-not_selected.39945fe6.svg";